import { FC } from 'react';
import './personal-account-qr-modal.scss';
import { useEnhancedTranslation } from '@app/hooks';
import { NewButton } from '@app/components/NewButton/NewButton';
import { QRCodeSVG } from 'qrcode.react';

type TProps = {
  number: string;
  onClose: () => void;
};

const PersonalAccountQRModal: FC<TProps> = ({ number, onClose }) => {
  const { t } = useEnhancedTranslation({ keyPrefix: 'account.personalAccount.qrCodeModal' });
  return (
    <div className="personal-account-qr-modal">
      <div className="personal-account-qr-modal__qr">
        <QRCodeSVG value={`;${number}=2026?`} />
      </div>
      <div className="personal-account-qr-modal__caption">{t('caption')}</div>
      <NewButton size="small" addClass="personal-account-qr-modal__btn" onClick={onClose}>
        {t('close')}
      </NewButton>
    </div>
  );
};

export default PersonalAccountQRModal;
